import { Event, track } from 'app/lib/analytics';
import type { SpecificNavigationProp } from 'app/types/navigation';
import { ListingType } from 'app/types/listing';
import { SharerType } from 'app/types/preferences';

function resetToMainExplore(navigation: SpecificNavigationProp<'borrowerNext'>, params?: { search?: string }) {
  navigation.getParent()?.reset({
    routes: [
      {
        name: 'main',
        state: {
          routes: [
            {
              name: 'billboard',
              state: {
                routes: [
                  {
                    name: 'all-listings',
                    params: {
                      type: ListingType.offer,
                      ...(params?.search ? { search: params.search } : {}),
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  });
}

export function useBorrowerNextScreen(navigation: SpecificNavigationProp<'borrowerNext'>) {
  const close = () => {
    track(Event.GiveUpOnboarding, { where: 'borrower-next' });
    resetToMainExplore(navigation);
  };

  const openInspiration = () => {
    navigation.navigate('interests', { sharerType: SharerType.borrower, skipExplain: true }, { pop: true });
  };

  const searchObject = (query: string) => {
    if (!query.trim()) {
      return;
    }
    resetToMainExplore(navigation, { search: query.trim() });
  };

  return { close, openInspiration, searchObject };
}
